import Rx from 'ub_wrapped/rx';

const subject = new Rx.Subject();

const pushMouseDownEvent = () => {
  const currentSelection = window.getSelection();

  if (currentSelection.rangeCount > 0) {
    subject.onNext({
      type: 'mouseDownOccurred',
      newSelection: currentSelection
    });
  }
};

Rx.Observable.fromEvent(document, 'mousedown').subscribe(pushMouseDownEvent);

export default {
  subject
};



// WEBPACK FOOTER //
// ./src/control/mouse-down-selection.js